import { render, staticRenderFns } from "./ColorDot.vue?vue&type=template&id=688507aa&"
import script from "./ColorDot.vue?vue&type=script&lang=js&"
export * from "./ColorDot.vue?vue&type=script&lang=js&"
import style0 from "./ColorDot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ColorDot.vue"
export default component.exports